
import store from '../config/store'

export default {
  props: {
    label: {
      type: String,
      default: null
    },
    content: {
      type: String,
      default: null
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'empty-folder_gray'
    },
    iconWidth: {
      type: Number,
      default: 200
    },
    iconHeight: {
      type: Number,
      default: 160
    }
  },

  data: () => ({
    store
  }),
  
  computed: {
    iconStyle () {
      return `width: ${this.iconWidth}px; height: ${this.iconHeight}px;`
    }
  }
}

